<template>
    <div class="mt-8 w-full h-full bg-white">
      <Permissions
        v-loading="loading"
        element-loading-text="Loading..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"/>
    </div>
  </template>

<script>
import Permissions from '../components/permissions/Permissions.vue';

export default {
  name: 'PermissionView',
  data() {
    return {
      loading: false,
    };
  },
  components: {
    Permissions,
  },
  methods: {
    async fetchPermissions() {
      try {
        this.$store.dispatch('SecurityModule/Permission/fetchAllPermissions');
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
    },
  },
  mounted() {
    this.loading = true;
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    this.fetchPermissions();
    this.loading = false;
  },
};
</script>

<style scoped></style>
